import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./info-card-item.style";
import pencilIcon from "@iconify/icons-mdi/pencil";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcInfoCardItemProps {
  label: string;
  value?: string;
  translation?: string;
  type?: string;
  onEdit?: (type: string) => void;
  editable?: boolean;
  isEditButtonDisabled?: boolean;
}

export const OcInfoCardItem: React.FC<OcInfoCardItemProps> = ({
  label,
  value,
  translation,
  type,
  onEdit,
  editable = false,
  isEditButtonDisabled,
}) => {
  const isMobile = useOcIsMobile();
  const classes = useStyles({ isMobile });
  const theme = useTheme();

  let effectiveValue = value || "";
  if (value === "not_defined") {
    effectiveValue = "";
  }

  const handleEdit = () => {
    if (isEditButtonDisabled) return null;
    if (type) {
      onEdit?.(type);
    }
  };

  const getTooLongValueTooltip = () => {
    if ((value ?? "").length > 30) {
      return (
        <Tooltip title={value} placement="top">
          <Box className={classes.value}>{effectiveValue}</Box>
        </Tooltip>
      );
    }
    return <Box className={classes.value}>{effectiveValue}</Box>;
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.label}>{label}</Box>
      {getTooLongValueTooltip()}
      <Box width="10px" />
      {editable ? (
        <Box
          style={
            isEditButtonDisabled ? { cursor: "auto" } : { cursor: "pointer" }
          }
          onClick={handleEdit}
        >
          <InlineIcon
            id={`pencilIcon-${translation}-${type}`}
            width="18px"
            height="18px"
            icon={pencilIcon}
            color={
              isEditButtonDisabled
                ? theme.palette.gray40.main
                : theme.palette.gray80.main
            }
          />
        </Box>
      ) : (
        <Box width="50px" /> //Due to responsive display
      )}
    </Box>
  );
};

export default OcInfoCardItem;
